
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetosuratinnovacabbooking() {



    const cardData =
    {
        keyword: 'Pune to Surat Innova Cabs Booking',
        heading: 'Meghana Cab : Pune to Surat Innova Cabs Booking',
        headingDescription: 'Meghana Cab offers Pune to Surat Innova Crysta Cabs Booking, delivering a premium, comfortable, and dependable travel experience for individuals, families, and corporate travelers. Covering approximately 420 km via the Mumbai–Pune Expressway and NH 48, our Innova Crysta cabs are ideal for long-distance journeys with their plush leather interiors, ample legroom, air-conditioning, and spacious luggage capacity. Whether you are visiting Surat for business, leisure, or family functions, our experienced chauffeurs ensure a smooth, safe, and timely ride. With options for one-way or round-trip bookings, transparent pricing, GPS-enabled vehicles, and 24/7 customer support, Meghana Cab guarantees a stress-free and luxurious Pune to Surat journey from doorstep to destination.',


        top: 'Top Places to Visit in Surat with Meghana Cab',

"topPlaces": [
  {
    "title": "Tapi Riverfront Walkway",
    "description": "A scenic riverside promenade along the Swami Vivekananda Bridge, ideal for sunrise/sunset strolls. Lined with food stalls, landscaped green spaces, and river views—great for leisurely outings."
  },
  {
    "title": "Dumas Beach",
    "description": "A semi-urban, black‑sand beach on the Arabian Sea, about 21 km from Surat. Famous for its eerie legend, marble shore, and vibrant food stalls serving Bhajiya, pav bhaji, and local snacks."
  },
  {
    "title": "Suvali (Swally) Beach",
    "description": "A clean urban beach about 25 km from Surat, historically known as Swally—where the modern Indian navy began. Its calm waves and smooth sands make it a pleasant picnic destination."
  },
  {
    "title": "Surat Castle (Old Fort)",
    "description": "A 16th‑century fortress built by Sultan Mahmood III to guard the port city. With massive gates, bastions, and thick stone walls, it stands as a prime example of medieval military architecture."
  },
  {
    "title": "Sardar Patel Museum & Planetarium",
    "description": "Originally founded in 1891, this museum houses relics, an art gallery, science exhibits, and an in‑house planetarium—offering both cultural and educational experiences."
  },
  {
    "title": "Science Centre",
    "description": "A multi‑facility edutainment complex with a planetarium, amphitheatre, art gallery, and space and textile exhibits. A family‑friendly attraction focusing on interactive learning and innovation."
  },
  {
    "title": "Dutch Garden",
    "description": "A European‑style cemetery in Nanpura with colonial-era tombs, fountains, and lawns set along the Tapi—ideal for a quiet, historical stroll."
  },
  {
    "title": "Amaazia Water Park",
    "description": "One of Asia’s largest water parks, featuring thrilling slides like King‑Cobra and Kamikaze, plus a snow park, bird park, and dining zones—perfect for family outings."
  },
  {
    "title": "Jagdish Chandra Bose Aquarium",
    "description": "India’s oldest aquarium in Surat, showcasing diverse marine life across multiple tanks—an engaging experience for children and marine enthusiasts."
  },
  {
    "title": "Sarthana Zoo (Nature Park)",
    "description": "A sprawling zoo and nature park with 490 animals across 54 species. Home to India’s only successful smooth‑coated otter breeding program and accommodating up to 50,000 visitors comfortably."
  }
],

   "services": [
    {
      "name": "Pune to Surat Innova Crysta Cab Booking",
      "description": "Book a comfortable and spacious Innova Crysta cab for your Pune to Surat journey. Ideal for families, business travelers, or groups, our cabs are equipped with AC, plush interiors, and experienced chauffeurs for a stress-free 6-8 hour road trip."
    },
    {
      "name": "One Way Innova Crysta Pune Surat",
      "description": "Looking for a one-way drop from Pune to Surat in an Innova Crysta? Enjoy competitive fixed fares, clean vehicles, and punctual pickup service. Ideal for airport transfers, relocation travel, or business visits with ample luggage space."
    },
    {
      "name": "Round Trip Innova Crysta Pune Surat",
      "description": "Plan a round-trip journey to Surat from Pune with our round-trip Innova Crysta packages. Get flexible return options, inclusive pricing, and full-time chauffeur support—perfect for short vacations or work-related stays."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Surat",
      "description": "Travel in comfort with our air-conditioned Innova Crysta taxis from Pune to Surat. Beat the heat on long drives with fully functional rear AC vents, spacious seating, and a smooth ride experience over highway terrain."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Surat",
      "description": "Let our experienced and courteous chauffeurs drive you safely from Pune to Surat. Our chauffeur-driven Innova Crysta offers you the luxury of a relaxed journey while we handle the navigation, traffic, and stops as per your convenience."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Surat",
      "description": "Enjoy a private, non-shared ride from Pune to Surat in our Innova Crysta. Ideal for family trips, corporate travel, or groups seeking privacy, our cabs offer direct pickup and drop service without delays or detours."
    },
    {
      "name": "Online Booking Innova Crysta Pune Surat",
      "description": "Book your Pune to Surat Innova Crysta online in just a few clicks. Get instant confirmation, transparent fares, and the flexibility to choose pickup timing and preferred seating configuration—all on a secure platform."
    },
    {
      "name": "Surat Tour Innova Crysta",
      "description": "Explore Surat’s attractions like Dumas Beach, textile markets, and Dutch Gardens with our full-day Innova Crysta tour packages. Local sightseeing made comfortable with ample legroom, charging ports, and an experienced local driver."
    },
    {
      "name": "Surat Airport Transfer Innova Crysta",
      "description": "Travel from Pune directly to Surat Airport with our reliable Innova Crysta airport transfer service. Get assured on-time arrival, luggage assistance, and smooth highway travel—available 24/7 for early or late-night flights."
    },
    {
      "name": "Family Travel Innova Crysta Surat",
      "description": "Make your family travel from Pune to Surat stress-free with our spacious Innova Crysta. With seating for 6-7 passengers, child-friendly interiors, and generous boot space, it's ideal for weekend getaways or family visits."
    },
    {
      "name": "Budget Cab Pune Surat Innova Crysta",
      "description": "Travel affordably without compromising comfort. Our budget-friendly Innova Crysta cabs from Pune to Surat include fuel, driver allowance, and tolls in a transparent price—no hidden fees, just great value."
    },
    {
      "name": "Surat Business Travel Innova Crysta",
      "description": "Our corporate Innova Crysta service caters to professionals traveling to Surat for meetings, expos, or client visits. Get Wi-Fi-enabled rides, invoice support, and an executive-grade driving experience with premium seating."
    },
    {
      "name": "Reliable Innova Crysta Taxi Pune Surat",
      "description": "Count on us for timely, well-maintained Innova Crysta cabs for your Pune–Surat route. All vehicles are GPS tracked, sanitized, and driven by licensed drivers trained for long-distance travel safety and customer support."
    },
    {
      "name": "Comfortable Pune Surat Innova Crysta",
      "description": "Experience a smooth and peaceful journey from Pune to Surat in our high-end Innova Crysta. Ideal for long hours on the road, our cabs offer reclining seats, air suspension, and refreshments on request."
    },
    {
      "name": "Surat Long Distance Innova Crysta Taxi",
      "description": "Book our Innova Crysta for long-distance trips to Surat and beyond. Designed for extended travel, our vehicles include ergonomic seating, multiple charging points, water bottles, and driver rotation for safety on 8+ hour trips."
    }
  ],
  "tableData": [
    ["Pune to Surat Innova Crysta Cab Booking", "One Way Innova Crysta Pune Surat"],
    ["Round Trip Innova Crysta Pune Surat", "AC Innova Crysta Taxi Pune Surat"],
    ["Chauffeur Driven Innova Crysta Pune Surat", "Private Innova Crysta Taxi Pune Surat"],
    ["Online Booking Innova Crysta Pune Surat", "Surat Tour Innova Crysta"],
    ["Surat Airport Transfer Innova Crysta", "Family Travel Innova Crysta Surat"],
    ["Budget Cab Pune Surat Innova Crysta", "Surat Business Travel Innova Crysta"],
    ["Reliable Innova Crysta Taxi Pune Surat", "Comfortable Pune Surat Innova Crysta"],
    ["Surat Long Distance Innova Crysta Taxi", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Cabs from Pune to Surat",
    "WhyChoosedescription": "Travel comfortably from Pune to Surat in our spacious and feature-rich Innova Crysta cabs. Whether it's for a business trip, family occasion, or leisure visit, we provide a smooth and premium travel experience for this 420+ km intercity route."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Long-Distance Travel",
    "WhyChoosedescription": "Our Innova Crysta cabs offer seating for 6–7 passengers, ample legroom, adjustable seats, and strong dual-zone AC—ideal for long hours of highway travel. Enjoy a relaxed journey through Maharashtra and Gujarat in absolute comfort."
  },
  {
    "WhyChooseheading": "Expert Drivers for a Safe and Smooth Ride",
    "WhyChoosedescription": "Our experienced and courteous chauffeurs are well-versed with the Pune–Surat route via NH48. They ensure timely travel, safe driving practices, and are ready to accommodate rest stops or quick detours if needed."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Every Innova Crysta in our fleet is cleaned, sanitized, and thoroughly checked before your journey. Our high maintenance standards ensure reliability and peace of mind during long-distance travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our Pune to Surat taxi fares include driver allowance, fuel charges, tolls, and interstate taxes—ensuring full transparency and zero surprise costs. Get premium service at competitive rates."
  },
  {
    "WhyChooseheading": "One-Way, Round-Trip, and Multi-Day Options Available",
    "WhyChoosedescription": "Whether you need a single drop to Surat, a return journey, or a multi-day visit, we offer flexible booking options tailored to your schedule and convenience."
  },
  {
    "WhyChooseheading": "Ideal for Business Travel, Family Trips & Group Travel",
    "WhyChoosedescription": "Whether you're traveling for textile business, family events, or a vacation, the Innova Crysta is the ideal cab for group journeys, combining comfort with spacious interiors and excellent road performance."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support with Easy Online Access",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, route changes, or special requests. Book online or over the phone for a quick and seamless reservation experience."
  }
]





























    }

const faqData = [
    {
        question: "How can I book an Innova cab from Pune to Surat?",
        answer: "You can easily book by calling Meghana Cab at +91 9075462128 or through our website for fast and secure booking."
    },
    {
        question: "What is the distance and travel time from Pune to Surat?",
        answer: "The distance is approximately 420 km, and the travel time is around 7 to 8 hours, depending on traffic and route."
    },
    {
        question: "Is Innova suitable for the long journey from Pune to Surat?",
        answer: "Yes, the Innova Crysta is ideal for long-distance travel, offering comfort, ample legroom, and smooth performance."
    },
    {
        question: "Can I book a one-way or round trip to Surat?",
        answer: "Yes, Meghana Cab offers both one-way and round-trip bookings for Pune to Surat travel."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate?",
        answer: "The Innova Crysta can comfortably seat 6 to 7 passengers with luggage."
    },
    {
        question: "Are your cabs sanitized before every journey?",
        answer: "Absolutely. All our vehicles are cleaned and sanitized before every trip to ensure safety and hygiene."
    },
    {
        question: "Do your drivers have experience with long intercity routes like Pune to Surat?",
        answer: "Yes, all our drivers are trained and experienced in long-distance travel and follow safe driving practices."
    },
    {
        question: "What’s included in the fare for Pune to Surat Innova cab service?",
        answer: "Our fares include fuel, driver charges, and tolls. Parking fees and extra waiting time may be additional."
    },
    {
        question: "Can I make multiple stops on the way to Surat?",
        answer: "Yes, extra stops can be arranged upon request. Please share your itinerary while booking."
    },
    {
        question: "What payment modes are available for booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ravi Thakur',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova for Pune to Surat. The cab was clean, comfortable, and the driver was very cooperative.”',
    },
    {
        name: 'Ms. Sheetal Mehta',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great long-distance ride experience. The Innova Crysta was perfect for our family trip to Surat.”',
    },
];


























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const puneToSuratInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Surat Innova Crysta Cab Booking",
  "description": "Book AC Innova Crysta taxi from Pune to Surat for one way, round trip, business travel, family trips, and airport transfers. Reliable and comfortable chauffeur-driven Innova Crysta service.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Surat"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-surat-innova-crysta-cab-booking"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Surat Innova Crysta Cab Booking | Reliable Taxi Service</title>
  <meta
    name="description"
    content="Book AC Innova Crysta cab from Pune to Surat for business, family trips, airport transfers, and round trips. Comfortable and budget-friendly taxi service."
  />
  <meta
    name="keywords"
    content="Pune to Surat Innova Crysta Cab Booking, One Way Innova Crysta Pune Surat, Round Trip Innova Crysta Pune Surat, AC Innova Crysta Taxi Pune Surat, Chauffeur Driven Innova Crysta Pune Surat, Private Innova Crysta Taxi Pune Surat, Online Booking Innova Crysta Pune Surat, Surat Tour Innova Crysta, Surat Airport Transfer Innova Crysta, Family Travel Innova Crysta Surat, Budget Cab Pune Surat Innova Crysta, Surat Business Travel Innova Crysta, Reliable Innova Crysta Taxi Pune Surat, Comfortable Pune Surat Innova Crysta, Surat Long Distance Innova Crysta Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToSuratInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/22.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetosuratinnovacabbooking;